import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=12e91c87&scoped=true&"
import script from "./DonutChart.vue?vue&type=script&lang=js&"
export * from "./DonutChart.vue?vue&type=script&lang=js&"
import style0 from "./DonutChart.vue?vue&type=style&index=0&id=12e91c87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e91c87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e91c87')) {
      api.createRecord('12e91c87', component.options)
    } else {
      api.reload('12e91c87', component.options)
    }
    module.hot.accept("./DonutChart.vue?vue&type=template&id=12e91c87&scoped=true&", function () {
      api.rerender('12e91c87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/DonutChart.vue"
export default component.exports